import React from 'react';
import PropTypes from 'prop-types';

import Checkbox from "jsx/elements/inputs/Checkbox";
import YesNo from "components/Display/YesNo";
import Date from "components/Display/ViewDate";
import Amount from "components/Display/Amount";

import TransactionKey from "../Display/TransactionKey";
import CostCalculatedFor from "../Display/CostCalculatedFor";
import RecordNumber from "../Display/RecordNumber";


class PaymentResultTable extends React.Component {

  state = {
    showPayments : false
  };

  constructor(props){
    super(props);
    this.showshowPaymentsClick = this.showshowPaymentsClick.bind(this);
  }

  showshowPaymentsClick(){
    //console.debug("This:");
    this.setState({ showPayments: !this.state.showPayments });
  };


  render() {
    if (!this.props.data.payments){
      return (
        <div/>
      );
    }
    let payments = this.props.data.payments;
    return (
      <div className="calc-setting-table">
        <table className="table">
          <colgroup>
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
          </colgroup>
          <thead>
          <tr>
            <th colSpan="13" className="text-left">
              <span className="calc-setting-table-header">Innborganir sem voru notaðar í útreikningum&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <input id="checkCostid1" type="checkbox" checked={this.state.showPayments} onChange={this.showshowPaymentsClick}/><label className="calc-small-checkbox-label" htmlFor="checkCostid1" >Sýna greiðslur</label>
            </th>
          </tr>
          <tr>
            <th className="text-left">Reiknað f.</th>
            <th className="text-left">Færsl.nr.</th>
            <th className="text-left">Færslulykill</th>
            <th className="text-right">Dagsetning</th>
            <th className="text-right">Innborgun</th>
            <th className="text-right">Óráðstafað</th>

            <th className="text-right">Höfuðst.</th>
            <th className="text-right">Vísit.</th>
            <th className="text-right">Samningsv.</th>
            <th className="text-right">Drv.</th>
            <th className="text-right">Hst.Drv</th>
            <th className="text-right">VSK</th>
            <th className="text-right">FTS</th>

          </tr>
          </thead>
          <tbody>
          {payments.map((item,i) => {
            return(
                <tr key={i + "inner"}>
                  <td className="text-left"><CostCalculatedFor data={item.calculatedFor}/></td>
                  <td className="text-left"><RecordNumber data={item.transactionNumber}/></td>
                  <td className="text-left"><TransactionKey data={item.transactionKey}/></td>
                  <td className="text-right"><Date data={item.paymentDate}/></td>
                  <td className="text-right"><Amount data={item.amount}/></td>
                  <td className="text-right"><Amount data={item.amountRemaining}/></td>
                  <td className="text-right"><Amount data={item.paidCapital}/></td>
                  <td className="text-right"><Amount data={item.paidIndex}/></td>
                  <td className="text-right"><Amount data={item.paidContractInterest}/></td>
                  <td className="text-right"><Amount data={item.paidPennaltyInterest}/></td>
                  <td className="text-right"><Amount data={item.paidCapitalizedPennaltyInterest}/></td>
                  <td className="text-right"><Amount data={item.paidVAT}/></td>
                  <td className="text-right"><Amount data={item.paidCapitalGainsTax}/></td>
                </tr>);
          })}
          </tbody>
        </table>
      </div>
    );
  }
}

PaymentResultTable.propTypes = {
  data: PropTypes.object,
};



export default PaymentResultTable;



// WEBPACK FOOTER //
// ./src/pages/Calculation/Results/PaymentResultTable.js